import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Tournament } from '../types';

interface TournamentState {
  currentTournament: Tournament | null;
  currentTournamentId?: Tournament['id'] | null;
  liveTournaments: Tournament[];
  incomingTournaments: Tournament[];
  portfolio: any[];
  isLoading: boolean;
  error: string | null;
  setTournament: (tournament: Tournament) => void;
  setTournamentId: (id: string) => void;
  updatePortfolio: (portfolio: any) => void;
}

export const useTournamentStore = create<TournamentState>()(
  devtools((set) => ({
    currentTournament: null,
    currentTournamentId: null,
    liveTournaments: [],
    incomingTournaments: [],
    isLoading: false,
    error: null,
    portfolio: [],
    setTournament: (tournament) =>
      set({ currentTournament: tournament, currentTournamentId: tournament.id, portfolio: []}),
    setTournamentId: (id) => set({ currentTournamentId: id }),
    updatePortfolio: (portfolio) => set({ portfolio })
  }))
);